(function () {
  "use strict";

  // Multi-execution guard. cclp-otp.js is loaded by the OTP tier picker
  // section, which renders cclp-assets.liquid on top. The script tag inserts
  // once but executes every time the section is included. Guard prevents
  // double-binding.
  if (window.__cclpOtpInit) return;
  window.__cclpOtpInit = true;

  // ---------- State ----------
  let selectedTierEl = null; // The currently-selected tier card DOM element
  let addonQtys = {};        // Map: addon SKU → quantity

  // ---------- DOM helpers ----------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function money(n) { return "$" + Number(n).toFixed(2).replace(/\.00$/, ""); }

  // ---------- Tier selection ----------
  function initTierSelection() {
    const tierButtons = $$("[data-cclp-select-tier]");
    tierButtons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        var card = btn.closest(".cclp-otp-tier-card");
        if (card) selectTier(card);
      });
    });

    $$(".cclp-otp-tier-card").forEach(function (card) {
      card.style.cursor = "pointer";
      card.addEventListener("click", function (e) {
        if (e.target.closest("[data-cclp-select-tier]")) return;
        selectTier(card);
      });
    });
  }

  function selectTier(card) {
    // Visual: clear prior selection, mark new one
    $$(".cclp-otp-tier-card").forEach(function (c) {
      c.classList.remove("cclp-otp-tier-card--selected");
    });
    card.classList.add("cclp-otp-tier-card--selected");
    selectedTierEl = card;

    // Reset add-on quantities (new tier = fresh start)
    addonQtys = {};
    $$("[data-cclp-addon-qty]").forEach(function (q) { q.textContent = "0"; });

    // Reveal the add-on selector
    const addOn = $("[data-cclp-add-on-selector]");
    if (addOn) {
      addOn.hidden = false;
    }

    // Reveal the cart preview
    const cart = $("[data-cclp-cart-preview]");
    if (cart) {
      cart.hidden = false;
    }

    // Apply free-addon grayouts based on the tier's free_addon_skus list
    applyFreeAddonGrayouts(card);

    // Toggle the free-shipping nudge for sub-threshold tiers
    toggleFreeShipNudge(card);

    // Recompute cart preview
    recomputeCart();

    // Enable Buy Now button
    const buyBtn = $("[data-cclp-buy-now]");
    if (buyBtn) buyBtn.disabled = false;

    // Smooth-scroll to add-on section
    if (addOn) {
      const yOffset = -80; // clear sticky announcement bar
      const y = addOn.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }

  function applyFreeAddonGrayouts(card) {
    const freeSkus = (card.getAttribute("data-tier-free-skus") || "")
      .split(",")
      .map(function (s) { return s.trim().toUpperCase(); })
      .filter(Boolean);

    $$(".cclp-addon-card").forEach(function (addonCard) {
      const sku = (addonCard.getAttribute("data-addon-sku") || "").toUpperCase();
      const isFree = sku && freeSkus.indexOf(sku) !== -1;
      addonCard.classList.toggle("cclp-addon-card--already-free", isFree);
      var badge = $("[data-cclp-addon-free-badge]", addonCard);
      if (badge) badge.hidden = !isFree;
    });
  }

  function toggleFreeShipNudge(card) {
    const nudge = $("[data-cclp-otp-free-ship-nudge]");
    if (!nudge) return;
    const addOnSelector = $("[data-cclp-add-on-selector]");
    if (!addOnSelector) {
      nudge.hidden = true;
      return;
    }
    const threshold = Number(addOnSelector.getAttribute("data-free-ship-threshold") || 60);
    const tierPrice = Number(card.getAttribute("data-tier-price") || 0);
    nudge.hidden = tierPrice >= threshold;
  }

  // ---------- Add-on stepper ----------
  function initAddonSteppers() {
    $$(".cclp-addon-card").forEach(function (card) {
      const sku = card.getAttribute("data-addon-sku");
      const max = Number(card.getAttribute("data-addon-max-qty") || 5);
      const qtyEl = $("[data-cclp-addon-qty]", card);
      const inc = $("[data-cclp-addon-inc]", card);
      const dec = $("[data-cclp-addon-dec]", card);
      if (!sku || !qtyEl) return;

      addonQtys[sku] = 0;

      if (inc) {
        inc.addEventListener("click", function (e) {
          e.preventDefault();
          const current = addonQtys[sku] || 0;
          if (current >= max) return;
          addonQtys[sku] = current + 1;
          qtyEl.textContent = String(addonQtys[sku]);
          recomputeCart();
        });
      }

      if (dec) {
        dec.addEventListener("click", function (e) {
          e.preventDefault();
          const current = addonQtys[sku] || 0;
          if (current <= 0) return;
          addonQtys[sku] = current - 1;
          qtyEl.textContent = String(addonQtys[sku]);
          recomputeCart();
        });
      }
    });
  }

  // ---------- Cart preview ----------
  function recomputeCart() {
    if (!selectedTierEl) return;

    const tierPrice = Number(selectedTierEl.getAttribute("data-tier-price") || 0);
    const tierName = selectedTierEl.getAttribute("data-tier-name") || "Bundle";
    const tierStrike = Number(selectedTierEl.getAttribute("data-tier-strike") || 0);

    let subtotal = tierPrice;
    const lines = [];
    lines.push({ name: tierName + " bundle", price: tierPrice });

    $$(".cclp-addon-card").forEach(function (card) {
      const sku = card.getAttribute("data-addon-sku");
      const qty = addonQtys[sku] || 0;
      if (qty <= 0) return;
      const price = Number(card.getAttribute("data-addon-price") || 0);
      const name = card.getAttribute("data-addon-name") || "Add-on";
      const lineTotal = price * qty;
      subtotal += lineTotal;
      lines.push({ name: qty + "× " + name, price: lineTotal });
    });

    // Shipping (only if tier price below threshold AND total below threshold)
    const addOnSelector = $("[data-cclp-add-on-selector]");
    const threshold = Number((addOnSelector && addOnSelector.getAttribute("data-free-ship-threshold")) || 60);
    const shipCost = Number((addOnSelector && addOnSelector.getAttribute("data-shipping-cost")) || 5.99);
    let shipping = subtotal < threshold ? shipCost : 0;
    const total = subtotal + shipping;

    // Render lines
    const linesEl = $("[data-cclp-cart-lines]");
    if (linesEl) {
      linesEl.innerHTML = lines.map(function (l) {
        return '<div class="cclp-cart-preview__line"><span>' + escapeHtml(l.name) +
               '</span><span>' + money(l.price) + '</span></div>';
      }).join("");
    }

    const subtotalEl = $("[data-cclp-cart-subtotal]");
    if (subtotalEl) subtotalEl.textContent = money(subtotal);

    const shipRow = $("[data-cclp-cart-ship-row]");
    const shipEl = $("[data-cclp-cart-ship]");
    if (shipEl) {
      shipEl.textContent = shipping > 0 ? money(shipping) : "FREE";
      shipEl.classList.toggle("cclp-cart-preview__ship--free", shipping === 0);
    }
    if (shipRow) shipRow.hidden = false;

    const totalEl = $("[data-cclp-cart-total]");
    if (totalEl) totalEl.textContent = money(total);

    const buyBtn = $("[data-cclp-buy-now]");
    const buyAmount = $("[data-cclp-buy-now-amount]", buyBtn);
    if (buyAmount) buyAmount.textContent = " — " + money(total);

    // Refresh the free-ship nudge based on combined total
    const nudge = $("[data-cclp-otp-free-ship-nudge]");
    if (nudge) nudge.hidden = subtotal >= threshold;
  }

  // ---------- Buy Now → cart permalink ----------
  function initBuyNow() {
    const buyBtn = $("[data-cclp-buy-now]");
    if (!buyBtn) return;

    buyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!selectedTierEl || buyBtn.disabled) return;

      const tierLineItems = selectedTierEl.getAttribute("data-tier-line-items") || "";
      const discountCode = selectedTierEl.getAttribute("data-tier-discount-code") || "";

      const lineItemParts = tierLineItems ? tierLineItems.split(",").map(function (s) { return s.trim(); }).filter(Boolean) : [];

      $$(".cclp-addon-card").forEach(function (card) {
        const sku = card.getAttribute("data-addon-sku");
        const qty = addonQtys[sku] || 0;
        if (qty <= 0) return;
        const variantId = card.getAttribute("data-addon-variant-id");
        if (!variantId) return;
        lineItemParts.push(variantId + ":" + qty);
      });

      if (!lineItemParts.length) {
        console.warn("[cclp-otp] No line items configured. Wire up tier_line_items + addon_variant_id before going live.");
        return;
      }

      // Build the cart permalink. Multiple discount codes pass as
      // comma-separated values in the ?discount= param (Shopify accepts this
      // for stacking combinable discounts).
      //
      // Note: analytics tagging now derives from the discount codes themselves
      // (handled in Shopify Flow), so we don't need to set a cart attribute.
      let url = "/cart/" + lineItemParts.join(",");
      const params = [];
      if (discountCode) {
        const codes = discountCode.split(",")
          .map(function (c) { return encodeURIComponent(c.trim()); })
          .filter(Boolean);
        if (codes.length) params.push("discount=" + codes.join(","));
      }
      params.push("return_to=" + encodeURIComponent("/checkout"));
      url += "?" + params.join("&");

      window.location.href = url;
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c];
    });
  }

  // ---------- Default-select the Most Popular tier on load ----------
  // Mirrors sub LP pattern: the "Most Popular" tier is pre-selected on page load
  // so the customer sees the recommended pick + the yellow checkmark from the start.
  // Locked 2026-05-27 per Kevin: "include the yellow checkmark when a tier is selected."
  function initDefaultSelection() {
    const popularCard = $(".cclp-otp-tier-card--popular");
    if (popularCard) {
      // Use a microtask delay so the page renders first, then we apply selection
      // without triggering the smooth-scroll (which would jump the user to §7b on load).
      setTimeout(function () {
        selectTierSilently(popularCard);
      }, 100);
    }
  }

  // Same as selectTier but skips the smooth-scroll behavior (used for default-select on load)
  function selectTierSilently(card) {
    $$(".cclp-otp-tier-card").forEach(function (c) {
      c.classList.remove("cclp-otp-tier-card--selected");
    });
    card.classList.add("cclp-otp-tier-card--selected");
    selectedTierEl = card;
    addonQtys = {};
    $$("[data-cclp-addon-qty]").forEach(function (q) { q.textContent = "0"; });

    const addOn = $("[data-cclp-add-on-selector]");
    if (addOn) addOn.hidden = false;
    const cart = $("[data-cclp-cart-preview]");
    if (cart) cart.hidden = false;

    applyFreeAddonGrayouts(card);
    toggleFreeShipNudge(card);
    recomputeCart();

    const buyBtn = $("[data-cclp-buy-now]");
    if (buyBtn) buyBtn.disabled = false;
    // No smooth-scroll here — silent selection on load.
  }

  // ---------- Save-badge pop on scroll-in (one-time) ----------
  function initSaveBadgePop() {
    const badges = $$(".cclp-otp-tier-card__banner-save");
    if (!badges.length) return;
    if (!("IntersectionObserver" in window)) {
      badges.forEach(function (b) { b.classList.add("is-visible"); });
      return;
    }
    const io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    badges.forEach(function (b) { io.observe(b); });
  }

  // ---------- Init on DOMContentLoaded ----------
  function init() {
    initTierSelection();
    initAddonSteppers();
    initBuyNow();
    initDefaultSelection();
    initSaveBadgePop();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
